import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography
} from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';
import MinusIcon from '../icons/Minus';
import Logo from './Logo';
import {Link as RouterLink} from 'react-router-dom'

const sections = [
  {
    title: 'Contact Us',
    links: [
      {
        title: 'Press',
        href: 'mailto:ender.nakamoto@gmail.com'
      },
      {
        title: 'Support',
        href: 'mailto:ender.nakamoto@gmail.com'
      }
    ]
  },
  {
    title: 'Company',
    links: [
      {
        title: 'FAQ',
        to: '/faq'
      },
      {
        title: 'Pricing',
        to: '/pricing'
      
      }
    ]
  },
  {
    title: 'Social',
    links: [
      {
        title: 'Discord',
        href: 'https://discord.gg/nY8KpZhdRp'
      },
      {
        title: 'Twitter',
        href: 'https://twitter.com/Moivre_ai'
      }
    ]
  }
];

const Footer = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.default',
      pb: 6,
      pt: {
        md: 15,
        xs: 6
      }
    }}
    {...props}
  >
    <Container maxWidth="lg">
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          md={3}
          sm={4}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            order: {
              md: 1,
              xs: 4
            }
          }}
          xs={12}
        >
          <Logo />
          <Typography
            color="textSecondary"
            sx={{ mt: 1 }}
            variant="caption"
          >
            © 2021 Moivre AI.
          </Typography>
        </Grid>
        {sections.map((section, index) => (
          <Grid
            item
            key={section.title}
            md={3}
            sm={4}
            sx={{
              order: {
                md: index + 2,
                xs: index + 1
              }
            }}
            xs={12}
          >
            <Typography
              color="textSecondary"
              variant="overline"
            >
              {section.title}
            </Typography>
            <List disablePadding>
              {section.links.map((link) => (
                <ListItem
                  disableGutters
                  key={link.title}
                  sx={{
                    pb: 0,
                    pt: 1
                  }}
                >
                  <ListItemAvatar
                    sx={{
                      alignItems: 'center',
                      display: 'flex',
                      minWidth: 0,
                      mr: 0.5
                    }}
                  >
                    <MinusIcon color="primary" />
                  </ListItemAvatar>
                  <ListItemText
                    primary={link.href ? (
                      <Link
                        href={link.href}
                        color="textPrimary"
                        variant="subtitle2"
                        target="_blank"
                        style={{textDecoration: "none"}}
                      >
                        {link.title}
                      </Link>
                    ) : (
                      <RouterLink
                        color="textPrimary"
                        variant="subtitle2"
                        target="_blank"
                        style={{textDecoration: "none", color: "white"}}
                        to={link.to}
                      >
                        {link.title}
                      </RouterLink>
                    )}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
        ))}
      </Grid>
      <Divider
        sx={{
          borderColor: (theme) => alpha(theme.palette.primary.contrastText, 0.12),
          my: 6
        }}
      />
      <Typography
        color="textSecondary"
        variant="caption"
      >
        <Link
          href='/tos'
          color="textPrimary"
          variant="subtitle2"
          target="_blank"
          style={{marginRight: 10}}
        >
          Terms of Service
        </Link>

        <Link
          href='/privacy_policy'
          color="textPrimary"
          variant="subtitle2"
          target="_blank"
        >
          Privacy Policy
        </Link>
      </Typography>
    </Container>
  </Box>
);

export default Footer;
